import React, { useState } from 'react';
import "../css/prodView.css";
import { FileEarmarkText, FileEarmarkPdf, Download, ArrowDownCircle, ArrowUpCircleFill } from 'react-bootstrap-icons';

const ProdContent = ({ description, documents = [], docsDir, about = {} }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleSection = (index) => {
        setActiveIndex(prevIndex => prevIndex === index ? null : index);
    };

    const renderBenefits = () => {
        if (!Array.isArray(description) || description.length === 0) return null;

        const splitIndex = Math.ceil(description.length / 2);
        const leftColumn = description.slice(0, splitIndex);
        const rightColumn = description.slice(splitIndex);

        return (
            <div className="product-description-container">
                {description.length > 10 ? (
                    <div className="benefits-columns">
                        <ul className="bullet-list left-column">
                            {leftColumn.map((item, index) => (
                                <li style={{ marginLeft: '10px' }} key={index}>{item}</li>
                            ))}
                        </ul>
                        <ul className="bullet-list right-column">
                            {rightColumn.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <ul className="bullet-list">
                        {description.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                )}
            </div>
        );
    };

    const renderDocuments = () => {
        if (!Array.isArray(documents) || documents.length === 0) return null;

        return (
            <div className="documents-container">
                {documents.map((doc, index) => {
                    const isPDF = doc.doC_PATH?.includes("pdf");
                    const isEXE = doc.doC_PATH?.includes("exe");
                    const icon = isPDF
                        ? <FileEarmarkPdf className="icon" />
                        : <FileEarmarkText className="icon" />;

                    const fullPath = `${docsDir}/${doc.doC_PATH}`;

                    const handleDocClick = (e) => {
                        e.preventDefault();
                        console.log("Opening document:", fullPath);

                        // For EXE files, trigger download
                        if (isEXE) {
                            const link = document.createElement('a');
                            link.href = fullPath;
                            link.download = doc.doC_PATH;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            return;
                        }

                        // For PDFs and other documents, open in new tab
                        window.open(fullPath, "_blank", "noopener,noreferrer");
                    };

                    return (
                        <a
                            key={index}
                            href={fullPath}
                            className="docs-Button"
                            onClick={handleDocClick}
                            target={isEXE ? undefined : "_blank"}
                            rel={isEXE ? undefined : "noopener noreferrer"}
                            download={isEXE ? doc.doC_PATH : undefined}
                        >
                            <div className="row">
                                <div className="col-10">{doc.doC_NAME}</div>
                                <div className="col-2 justify-content-end">
                                    {isEXE ? <Download className="icon" /> : icon}
                                </div>
                            </div>
                        </a>
                    );
                })}
            </div>
        );
    };

    const renderAbout = () => {
        if (!about || typeof about !== 'object' || Array.isArray(about) || Object.keys(about).length === 0) return null;

        return (
            <div>
                {Object.entries(about).map(([header, content]) => (
                    <div key={header}>
                        <h2>{header}</h2>
                        {Array.isArray(content) ? (
                            <ul className="bullet-list">
                                {content.map((line, index) => (
                                    <li key={index}>{line}</li>
                                ))}
                            </ul>
                        ) : (
                            <p>{content}</p>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    const sections = [
        { title: 'About the product', content: renderAbout() },
        { title: 'Benefits', content: renderBenefits() },
        { title: 'Documents', content: renderDocuments() },
    ];

    return (
        <div style={{ width: '100%' }}>
            <h3 style={{ fontSize: '2.5rem', marginLeft: '1%', textDecoration: 'underline' }}>
                More Information:
            </h3>
            <div className="prod-info-container">
                {sections.map((section, index) => (
                    section.content && (
                        <div key={index} className="prod-info-block">
                            <div onClick={() => toggleSection(index)} className="prod-info-titles">
                                <span>{section.title}</span>
                                <span className="icon-wrapper">
                                    {activeIndex === index
                                        ? <ArrowUpCircleFill style={{ color: 'red' }} />
                                        : <ArrowDownCircle />}
                                </span>
                            </div>
                            <div className={`prod-info-content ${activeIndex === index ? 'open' : ''}`}>
                                {section.content}
                            </div>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default ProdContent;